module.exports = __webpack_public_path__ + "img/3Dian5_5.f7c8c587.png";